import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\AppController::status
 * @see app/Http/Controllers/AppController.php:166
 * @route '/maintenance-window'
 */
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/maintenance-window',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AppController::status
 * @see app/Http/Controllers/AppController.php:166
 * @route '/maintenance-window'
 */
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AppController::status
 * @see app/Http/Controllers/AppController.php:166
 * @route '/maintenance-window'
 */
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AppController::status
 * @see app/Http/Controllers/AppController.php:166
 * @route '/maintenance-window'
 */
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AppController::status
 * @see app/Http/Controllers/AppController.php:166
 * @route '/maintenance-window'
 */
    const statusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: status.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AppController::status
 * @see app/Http/Controllers/AppController.php:166
 * @route '/maintenance-window'
 */
        statusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: status.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AppController::status
 * @see app/Http/Controllers/AppController.php:166
 * @route '/maintenance-window'
 */
        statusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: status.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    status.form = statusForm
const maintenanceWindow = {
    status: Object.assign(status, status),
}

export default maintenanceWindow